// extracted by mini-css-extract-plugin
export var subheading = "SubHeading-module--subheading--fd41e";